import * as React from 'react';
import { Transition } from 'react-transition-group';
import { GridCollapseContext } from '..';
const GridCollapseTrigger = (props) => {
    const { isOpen, toggle } = React.useContext(GridCollapseContext);
    const renderContent = (state) => {
        return React.Children.map(props.children, ch => {
            const classArray = ['grid-collapse-trigger'];
            if (state) {
                classArray.push(`grid-collapse-trigger--${state}`);
            }
            if (React.isValidElement(ch)) {
                return React.cloneElement(ch, {
                    className: classArray.join(' '),
                    isActive: isOpen,
                    onClick: (event) => {
                        event.preventDefault();
                        if (ch.props.onClick) {
                            ch.props.onClick(event);
                        }
                        /* istanbul ignore else */
                        if (toggle) {
                            toggle();
                        }
                    },
                });
            }
        });
    };
    if (props.fadeOutOnOpen) {
        return (React.createElement(Transition, { in: !isOpen, timeout: { exit: 150 } }, renderContent));
    }
    return React.createElement(React.Fragment, null, renderContent());
};
export default GridCollapseTrigger;
